import ManeeshPortfolio from "./ManeeshPortfolio";

function App() {
  return <ManeeshPortfolio />;
}

export default App;
